import { useLoaderData, useSubmit } from "react-router-dom";
import { useGlobal } from "../../components/GlobalProviderLayout";
import { IToast, OPEN_TOAST } from "../../components/GlobalProviderLayout/GlobalProviderLayoutModel";
import { packObjForSubmit, unpackObjForSubmit } from "../../utils";
import { doFetch } from "../../utils/doFetch";
import { doFetchPut } from "../../utils/doFetchPut";
import { SecurityQuestion } from "./SecurityQuestion";
import { ISecurityQuestionData } from "./SecurityQuestionData";

export const securityQuestionRouteLoader = async ({ request }: { request: any, params: any }) => {
  return doFetch('my-profile-question-answer', { signal: request.signal }, true, true);
}

export const securityQuestionRouteAction = async ({ request }: { request: any, params: any }) => {
  let formData = await request.formData();
  let obj = JSON.parse(unpackObjForSubmit(formData));
  return doFetchPut('my-profile-question-answer', { signal: request.signal }, obj)
}

export const SecurityQuestionRoute = () => {
  const data = useLoaderData() as ISecurityQuestionData;
  const submit = useSubmit();
  const global = useGlobal();

  const onSubmit = async (data: ISecurityQuestionData) => {
    const formData = packObjForSubmit(data);

    await submit(formData, {
      method: "put",
      action: "/security-question",
    });

    const payload: IToast = {
      msg: "Security Question updated successfully",
      severity: "info",
    };
    global.dispatch({ type: OPEN_TOAST, payload });
  };

  const securityQuestionProps = { onSubmit, data };
  return (
    <SecurityQuestion {...securityQuestionProps} />
  )
}